import cloneDeep from 'lodash.clonedeep';

import { MergeAssets } from '.';
import { GameDocument } from '../../../types/game-document';
import { DEFAULT_RESOURCE_CATEGORIES } from '../../../constants/resource-categories';

export const AddNewAdditionalResourceCategoryAsync = async (
  gameDocument: GameDocument,
  newCategory: string
) => {
  if (!newCategory || newCategory.trim() === '') {
    return gameDocument;
  }

  const categoryTrimmed = newCategory.trim();

  // Check if it exists in the default list
  const isDefaultCategory = DEFAULT_RESOURCE_CATEGORIES.some(
    (c) => c.toLowerCase() === categoryTrimmed.toLowerCase()
  );
  if (isDefaultCategory) {
    return gameDocument;
  }

  const categories =
    cloneDeep(gameDocument.assets.additionalResourceCategories) ?? [];
  const categoryExist = categories.some(
    (c) => c.toLowerCase() === categoryTrimmed.toLowerCase()
  );

  if (!categoryExist) {
    categories.push(categoryTrimmed);
  }

  return MergeAssets(gameDocument, categories as any, 'additionalResourceCategories');
};
